import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { CompetitorPromotionState, CompetitorPromotionData, CompetitorInfo } from '../../components/competitorPromotions/types';

const initialState: CompetitorPromotionState = {
  data: null,
  competitors: [],
  loading: false,
  error: null,
};

const competitorPromotionSlice = createSlice({
  name: 'competitorPromotion',
  initialState,
  reducers: {
    fetchCompetitorPromotionRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchCompetitorPromotionSuccess: (
      state,
      action: PayloadAction<{ data: CompetitorPromotionData; competitors: CompetitorInfo[] }>
    ) => {
      state.loading = false;
      state.data = action.payload.data;
      state.competitors = action.payload.competitors;
      state.error = null;
    },
    fetchCompetitorPromotionFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCompetitorPromotionRequest,
  fetchCompetitorPromotionSuccess,
  fetchCompetitorPromotionFailure,
} = competitorPromotionSlice.actions;

export default competitorPromotionSlice.reducer;
